import React from 'react'
import { Info } from 'lib/lucide'

import { useStyles } from './styles'

interface NoticeProps {
  children: React.ReactNode
}

const Notice: React.FC<NoticeProps> = ({ children }) => {
  const classes = useStyles()

  return (
    <div className={classes.root} role="status">
      <span className={classes.icon}>
        <Info size={20} />
      </span>
      <span className={classes.text}>{children}</span>
    </div>
  )
}

export { Notice }
